<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4>{{title | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="main">
        <form [formGroup]="form" (ngSubmit)="senderDetailsUpdate()">
          <div class="form-group">
            <label class="vox-field-label">{{senderDetails.senderType | translate}}</label>
            <div ngbDropdown class="vox-dropdown-input mb-4" placement="bottom">
              <button class="dropdown__btn" id="sender-type-dropdown" type="button" ngbDropdownToggle [attr.disabled]="loading ? 'disabled' : null">
                <span>{{'company.sms.add.form.sender-types.'+ selectedSenderType.label | translate}}</span>   
              </button>
              <div ngbDropdownMenu aria-labelledby="sender-type-dropdown" class="dropdown-menu">
                <button ngbDropdownItem class="dropdown__item" type="button" *ngFor="let t of senderTypes"
                  (click)="onTypeSelect(t)">
                  <span>{{'company.sms.add.form.sender-types.' + t.label | translate}}</span>
                </button>
              </div>
            </div>
            <label class="vox-field-label" *ngIf="!showSenderName && senderDetails?.companyDids?.length">{{senderDetails.provider | translate}}</label>
            <div ngbDropdown *ngIf="!showSenderName && senderDetails?.companyDids?.length" class="vox-dropdown-input mb-4" placement="bottom">
              <button class="dropdown__btn" id="phone-number-dropdown" type="button" ngbDropdownToggle [attr.disabled]="loading ? 'disabled' : null">
                <span>{{selectedSenderDid?.number}}</span>
              </button>
              <div ngbDropdownMenu aria-labelledby="phone-number-dropdown" class="dropdown-menu company-dids">
                <button ngbDropdownItem class="dropdown__item" type="button" *ngFor="let did of senderDetails.companyDids"
                  (click)="onProviderSelect(did)">
                  <span>{{did.number}}</span>
                </button>
              </div>
            </div>
            <label class="vox-field-label" *ngIf="showSenderName">{{senderDetails.label | translate}}</label>
            <div class="vox-input-group vox-input-group_dense mb-4" *ngIf="showSenderName"
              [ngClass]="{ 'vox-input-group_invalid': (form.touched && form.invalid)}">
              <input type="text" placeholder='{{senderDetails.placeholder | translate}}' name="senderName" class="vox-text-field"
                formControlName="senderName" [attr.disabled]="loading ? 'disabled' : null" />
              <i class="vox-text-field__icon icon-small-alert"></i>
              <span *ngIf="senderNameError" class="vox-input-group__error-message">
                {{ senderNameError | translate }}
              </span>
            </div>
            <div *ngIf="senderDetails?.companyDids?.length === 0 && !showSenderName"
              class="vox-inline-message vox-inline-message_light-grey">
              <div>
                <i class="icon-small-info"></i>
                <span [innerHTML]="'company.sms.error.no-dids' | translate"></span>
              </div>
              <button type="button" class="vox-btn vox-btn-secondary retry-btn" (click)="getDids()" [ladda]="retryCompanyDids"
                data-style="zoom-in" data-spinner-color="#fff">
                <span translate>company.sms.retry-button</span>
              </button>
            </div>
          </div>
          <button *ngIf="SenderType.ALPHANUMERIC === selectedSenderType.value || (selectedSenderType.value === SenderType.LONG_NUMBER && senderDetails?.companyDids?.length) " class="vox-btn vox-btn-secondary" [ladda]="loading"
            [disabled]="form.invalid || isFormUnchanged()" type="submit" data-style="zoom-in">
            {{btnText | translate}}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>